import Utils from 'files/Utils.js';

const Appearance = {
    colors: {
        primary: () => {
            return '#3CB878';
        },
        secondary: () => {
            return '#239E70';
        },
        tertiary: () => {
            return '#C8E7B0';
        },
        soft: () => {
            return window.theme === 'dark' ? 'rgba(45,45,45,1)' : 'rgba(245,245,245,1)';
        },
        grey: () => {
            return window.theme === 'dark' ? '#606060' : '#9B9B9B';
        },
        altGrey: () => {
            return window.theme === 'dark' ? '#707070' : '#B3B3B3';
        },
        text: () => {
            return window.theme === 'dark' ? 'white' : '#232323';
        },
        subText: () => {
            return 'rgba(150,150,150,1)';
        },
        background: (options = {}) => {
            let alpha = options.alpha >= 0 ? options.alpha : 1;
            return window.theme === 'dark' ? `rgba(25,25,25,${alpha})` : `rgba(240,241,245,${alpha})`;
        },
        componentBackground: () => {
            return window.theme === 'dark' ? 'rgba(55,55,55,1)' : 'rgba(255,255,255,1)';
        },
        loginBackground: () => {
            return window.theme === 'dark' ? Appearance.colors.background() : Appearance.colors.primary();
        },
        panelBackground: () => {
            return window.theme === 'dark' ? 'rgba(45,45,45,1)' : 'rgba(250,250,250,1)';
        },
        panelMobileTabBackground: () => {
            return window.theme === 'dark' ? 'rgba(35,35,35,1)' : 'rgba(235,235,235,1)';
        },
        layerBackground: () => {
            return window.theme === 'dark' ? '#2D2D2D' : '#FAFAFA';
        },
        alert: () => {
            return window.theme === 'dark' ? 'rgba(45,45,45,1)' : 'rgba(245,245,245,1)';
        },
        sheet: () => {
            return window.theme === 'dark' ? 'rgba(45,45,45,1)' : 'rgba(245,245,245,1)';
        },
        dropDown: () => {
            return window.theme === 'dark' ? 'rgba(35,35,35,1)' : 'white';
        },
        textField: () => {
            return window.theme === 'dark' ? 'rgba(55,55,55,1)' : 'rgba(245,245,245,1)';
        },
        divider: () => {
            return 'rgba(150,150,150,0.15)';
        },
        darkDivider: () => {
            return 'rgba(150,150,150,0.35)';
        },
        softBorder: () => {
            return window.theme === 'dark' ? 'rgba(85,85,85,1)' : 'rgba(220,220,220,1)';
        },
        icon: () => {
            return window.theme === 'dark' ? '#FFFFFF' : 'rgba(220,220,220,1)';
        },
        timeOfDay: key => {
            switch(key) {
                case 'morning':
                return '#D5AC6B';

                case 'noon':
                return '#A48F74';

                case 'afternoon':
                return '#7F6453';

                case 'evening':
                return '#4C4C69';

                default:
                return '#4A4A4A';
            }
        },
        softGradient: color => {
            return `linear-gradient(45deg, ${Utils.hexToRGBA(color, 0.85)}, ${Utils.hexToRGBA(color, 0.7)})`
        },
        sensor: {
            green: '#95D78F',
            yellow: '#F0DD6B',
            red: '#F4745F'
        },
        red: '#F45D4C',
        darkRed: '#982F23',
        orange: '#EE8A2F',
        gold: '#F5B44F',
        yellow: '#E6C02A',
        blue: '#4A90E2',
        green: '#6CBF66',
        darkGreen: '#5E905C',
        teal: '#5AD8BC',
        darkBlue: '#153B67',
        purple: '#7A5EB3',
        brown: '#674429',
        lightGrey: '#9B9B9B',
        lighterGrey: '#BDBDBD',
        darkGrey: '#4A4A4A',
        darkerGrey: '#232323',
        dim: 'rgba(0,0,0,0.45)',
        transparent: 'rgba(0,0,0,0)',
        duracode: '#F7B500'
    },
    panelOptionsButton: () => {
        return {
            backgroundColor: window.theme === 'dark' ? 'rgba(140,140,140,1)' : Appearance.colors.lightGrey
        }
    },
    sidebar: {
        icons: {
            color: () => {
                return window.theme === 'dark' ? 'rgba(200,200,200,0.5)' : 'rgba(127,127,127,0.5)'
            }
        }
    },
    mapStyle: () => {
        return {
            border: '1px solid ' + (window.theme === 'dark' ? 'rgba(150,150,150,0.25)' : 'rgba(0,0,0,0)'),
            borderRadius: '7px'
        }
    },

    textStyles: {
        defaultText: props => {
            return {
                color: Appearance.colors.text(),
                display: 'block',
                fontSize: 14,
                fontWeight: 400,
                lineHeight: 1.5,
                ...props
            }
        },
        defaultTextSmall: props => {
            return {
                color: Appearance.colors.text(),
                fontSize: 12,
                fontWeight: 500,
                lineHeight: 1.5,
                ...props
            }
        },
        headerFontSize: () => {
            return Utils.isMobile() ? 32 : 36;
        },
        leadLandingTitle: props => {
            return {
                color: Appearance.colors.text(),
                display: 'block',
                fontSize: Utils.isMobile() ? 22 : 32,
                fontWeight: 800,
                fontFamily: 'Zen Dots',
                lineHeight: 1.25,
                ...props
            }
        },
        standard: props => {
            return {
                color: Appearance.colors.text(),
                fontWeight: 600,
                fontSize: 13,
                ...props
            }
        },
        supporting: props => {
            return {
                color: Appearance.colors.subText(),
                fontWeight: 500,
                fontSize: 12,
                ...props
            }
        },
        panelHeaderText: props => {
            if(Utils.isMobile() === true) {
                return {
                    color: Appearance.colors.text(),
                    fontSize: 20,
                    fontWeight: 800,
                    fontFamily: 'Zen Dots',
                    ...props
                }
            }
            return {
                color: Appearance.colors.text(),
                fontSize: 36,
                fontFamily: 'Zen Dots',
                ...props
            }
        },
        panelSubHeaderText: props => {
            if(Utils.isMobile() === true) {
                return {
                    color: Appearance.colors.text(),
                    fontSize: 17,
                    fontWeight: 800,
                    fontFamily: 'Zen Dots',
                    ...props
                }
            }
            return {
                color: Appearance.colors.text(),
                fontSize: 22,
                fontFamily: 'Zen Dots',
                ...props
            }
        },
        heavyHeader: props => {
            return {
                color: Appearance.colors.text(),
                fontWeight: 800,
                fontSize: 20,
                maxWidth: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                ...props
            }
        },
        header: props => {
            return {
                color: Appearance.colors.text(),
                display: 'block',
                fontWeight: 700,
                fontSize: Utils.isMobile() ? 14 : 16,
                lineHeight: 1.25,
                maxWidth: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                ...props
            }
        },
        subHeader: props => {
            return {
                color: Appearance.colors.text(),
                fontWeight: 700,
                fontSize: 14,
                maxWidth: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                ...props
            }
        },
        layerItemTitle: props => { 
            return {
                color: Appearance.colors.text(),
                display: 'block',
                fontWeight: 700,
                fontSize: 18,
                maxWidth: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                ...props
            }
        },
        title: props => {
            return {
                color: Appearance.colors.text(),
                fontWeight: 700,
                fontSize: 14,
                maxWidth: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                ...props
            }
        },
        subTitle: props => {
            return {
                color: Appearance.colors.subText(),
                fontWeight: 500,
                fontSize: 12,
                maxWidth: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                ...props
            }
        },
        key: props => {
            return {
                color: Appearance.colors.text(),
                fontWeight: 600,
                fontSize: 12,
                minWidth: 100,
                maxWidth: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                ...props
            }
        },
        value: props => {
            return {
                color: Appearance.colors.subText(),
                fontWeight: 500,
                fontSize: 12,
                textAlign: 'right',
                whiteSpace: 'break-spaces',
                ...props
            }
        },
    },

    styles: {
        bottomBorder: () => `1px solid ${Appearance.colors.divider()}`,
        panel: () => {
            return {
                borderRadius: 16,
                backgroundColor: Appearance.colors.panelBackground(),
                boxShadow: window.theme === 'dark' ? '5px 5px 15px rgba(0,0,0,0.25)' : '5px 5px 15px rgba(175,175,174,0.25)',
                borderWidth: 4,
                borderStyle: 'solid',
                borderColor: window.theme === 'dark' ? '#191919' : '#FFFFFF'
            }
        },
        panelPadding: props => {
            let mobile = Utils.isMobile() === true;
            if(props && mobile === true) {
                return props.responsive;
            }
            return mobile ? 24 : '3vw';
        },
        panelSpacing: props => {
            let mobile = Utils.isMobile() === true;
            if(props && mobile === true) {
                return props.responsive;
            }
            return mobile ? 48 : '4vw';
        },
        unstyledPanel: props => {
            return {
                overflow: 'hidden',
                backgroundColor: Appearance.colors.panelBackground(),
                borderColor: Appearance.colors.divider(),
                borderRadius: 16,
                borderStyle: 'solid',
                borderWidth: 2,
                ...props
            }
        },
        unstyledResponsivePanel: () => {
            let mobile = Utils.isMobile() === true;
            return {
                backgroundColor: Appearance.colors.panelBackground(),
                borderRadius: mobile ? 0 : 16,
                overflow: 'hidden'
            }
        },
        header: () => {
            return {
                borderTopLeftRadius: 10,
                borderTopRightRadius: 10,
                padding: Utils.isMobile() ? '8px 10px 8px 10px' : 10,
                borderBottom: `1px solid ${window.theme === 'dark' ? 'rgba(35,35,35,1)' : 'rgba(235,235,235,1)'}`
            }
        }
    },
    icons: {
        standard: () => {
            return {
                width: 30,
                height: 30,
                borderRadius: 17.5,
                objectFit: 'cover',
                backgroundColor: Appearance.colors.primary(),
                boxShadow: window.theme === 'dark' ? '3px 3px 7px rgba(0,0,0,0.25), -3px -3px 7px rgba(174,174,174,0.1)' : '3px 3px 7px #c9c8ca, -3px -3px 7px #ffffff'
            }
        }
    },
    boxShadow: props => {

        let light = props ? props.light : null;
        let dark = props ? props.dark : null;

        return `${dark && dark.offset ? dark.offset.top : 2.5} ${dark && dark.offset ? dark.offset.left : 2.5} ${dark ? dark.radius : 7.5} ${window.theme === 'dark' ? `rgba(0,0,0,0.075)`:'rgba(0,0,0,0.35)'}, ${light && light.offset ? light.offset.top : -2.5} ${light && light.offset ? light.offset.left : -2.5} ${light ? light.radius : 5} ${window.theme === 'dark' ? 'rgba(85,85,85,0.075)' : 'rgba(85,85,85,0.35)'}`;
    }
}
export default Appearance;
